(function ($) {

    'use strict';

    const Carousel = function () {

        let $carousels = $('[data-js-carousel]').not('.slick-initialized');
        let carousel;
        let $banner;

        const init = function () {
            $carousels.each(function (n, el) {
                const $carousel = $(el)

                _createCarousel($carousel);
                _addEvents($carousel);

                if ($carousel.parents('.carousel--testimonial').length) {
                    _positionArrows($carousel);
                    _setupPlayPause($carousel);
                }
            });
        };

        /**
         * Setup carousels
         */
        const _createCarousel = function ($carousel) {
            if ($('[data-js-carousel]')) {
                $carousel.on('init', () => {
                    const totalSlides = $('[data-js-carousel-slide]', $carousel).length;
                    const $dots = $('.slick-dots', $carousel);

                    if (totalSlides) {
                        $carousel.find('.slick-slide').each(function (i) {
                            $(this).attr('aria-label', `slide ${i + 1} of ${totalSlides}`);
                            $(this).attr('aria-roledescription', 'slide');
                        });
                    }

                    if ($dots.length) {
                        $('li', $dots).each(function (i, dot) {
                            const $dot = $(dot);
                            const $button = $dot.find('button');

                            $dot.removeAttr('aria-hidden');
                            $button.attr('aria-label', `Select slide ${i + 1}`);
                        });
                    }
                });

                carousel = $carousel.slick();
            }
        };

        /**
         * Add Events
         */
        const _addEvents = function ($carousel) {
            $banner = $carousel.parents('.banner');

            if ($banner.length) {
                $banner.attr("data-js-current-slide", 1);
                $carousel.on('beforeChange', handleSlideChange);
            }
        };

        const handleSlideChange = function (event, currentSlide) {
            $banner.attr("data-js-current-slide", carousel.slick('slickCurrentSlide') + 1);
        }

        /**
         * Set position of arrows so that they don't overlap with the slick dots
         */
        const _positionArrows = function ($carousel) {
            let $dots = $carousel.find('.slick-dots');

            if (!$dots.length) {
                return;
            }

            $carousel.find('.slick-prev').css('left', 'calc(50% - 45px - ' + $dots.width() / 2 + 'px)');
            $carousel.find('.slick-next').css('right', 'calc(50% - 45px - ' + $dots.width() / 2 + 'px)');
        };

        /**
         * Add Play / Pause functionality if button exists
         */
        const _setupPlayPause = function ($carousel) {
            let $button = $carousel.parent().find('[data-js-carousel-pause]');

            if (!$button.length) {
                return;
            }

            $button.on('click', _handleClick);
        };

        const _handleClick = function (e) {
            let $button = $(e.target);
            let $carousel = $button.parent().find('[data-js-carousel]');

            if (!$carousel.length) {
                return;
            }

            let isPaused = $carousel.slick('getSlick').paused;

            if (isPaused) {
                $carousel.slick('slickPlay');
                $button.text('Pause');
            } else {
                $carousel.slick('slickPause');
                $button.text('Play');
            }
        };


        return {
            init: init
        };

    }();

    module.exports = Carousel;

})(jQuery);
